
import { Component, Vue } from 'vue-property-decorator';
import PageTabs from '@/components/PageTemplate/PageTabs.vue';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: { PageTabs },
})
export default class Context extends Vue {
  get contextLinks(): { name: TranslateResult; routeName: string }[] {
    return [
      {
        name: this.$t('context.interactiveTool'),
        routeName: 'ContextInteractiveTool',
      },
      {
        name: this.$t('context.scenarios'),
        routeName: 'ContextScenarios',
      },
    ];
  }
}
